<template>
    <div class="gameAdjustments">
        <div class="winUp d-flex align-items-center flex-column pt-2">
            {{ 'win_up_to' | lang }}
            <div class="amount">
                {{winUp | currency}}
            </div>
        </div>
        <div class="ticketPrices d-flex justify-content-start align-items-center pl-3 pr-3 pl-md-0 pr-md-0 flex-wrap">
            <span class="title">{{ 'ticket_price' | lang }}</span> 
            <div :class="{'slider flex-grow-1':true, 'last-one-selected':lastAmountSelected, 'first-one-selected':firstAmountSelected}">
                <vue-slider
                v-model="value"
                :data="data"
                :data-value="'id'"
                :data-label="'name'"
                :disabled="ticketInProgress"
                tooltip = "always"
                ></vue-slider>
                <div class="w-100 d-flex justify-content-between min-max pt-2"> 
                    <span>{{minAmount | currency}}</span>
                    <span>{{maxAmount | currency}}</span>
                </div>
            </div>
            <!--<VueSlider :data-value="'id'" :data-label="'name'" :values="sliderValues" v-model="slider" />!-->
        </div>
    </div>
</template>

<script>

import { mapState, mapGetters, mapMutations } from 'vuex';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
    components: {
      VueSlider
    },
    data() {
        return {
            value: Config.current_amount['id'],
            data: Config.amounts.map(({ id, amount }) =>
                ({ id, name: this.$options.filters.currency(amount) })),
            maxAmount: Config.amounts[Config.amounts.length-1].amount,
            minAmount: Config.amounts[0].amount
        }
    },
    methods: {
        ...mapMutations(['updateCurrentAmount', 'setAmountWon']),
        changeAmount(index) {
            if(this.$store.state.amounts[index]) {
                this.updateCurrentAmount(this.$store.state.amounts[index]);
                
                this.setAmountWon(false); //If game was played and we still show amount won we want to show possible win after user changes amount
            }
        },
    },
    computed: {
        ...mapGetters(['winUp']),
        ...mapState([
            'ticketInProgress',
        ]),
        firstAmountSelected() {
            return this.data[0].id === this.value;

        }, 
        lastAmountSelected() {
            return this.data[this.data.length-1].id === this.value;
        }
    },
    watch: {
        value(value) {
            const index = this.$store.state.amounts.findIndex(amount => amount.id === value);

            if(index !== undefined) {
                this.changeAmount(index);
            }
        },
    },
}
</script>